import { render, staticRenderFns } from "./sfc-logo-mobile-black.vue?vue&type=template&id=ec201f06&scoped=true&lang=pug&"
import script from "./sfc-logo-mobile-black.vue?vue&type=script&lang=js&"
export * from "./sfc-logo-mobile-black.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec201f06",
  null
  
)

export default component.exports